module.exports = __webpack_public_path__ + "static/media/668JettStNW_2018-06-26_194.3f037b18.jpg";